module.exports = __webpack_public_path__ + "img/lottery-title.2387bf12.png";